
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AddCopyJielongPop extends Vue {
    @Prop({ type: String, default: "" }) draftActivityId!: string;

    show = false;

    get hasDraft (): boolean {
        return !!this.draftActivityId;
    }

    onOpen () {
        this.show = true;
    }

    onClose () {
        this.show = false;
    }

    onAddJielong () {
        this.$router.push("/newJielong");
    }

    onCopyJielong () {
        this.show = false;
        this.$router.push("/jielong/copy");
    }

    onDrafts () {
        if (!this.hasDraft) return;
        this.show = false;
        this.$router.push({
            path: "/newJielong",
            query: { id: this.draftActivityId, type: "draft" },
        });
    }
}
